module.exports = __webpack_public_path__ + "img/importFileIcon.3c0a17bc.svg";